import { gsap } from 'gsap';

export default class Announce2nd {
    constructor() {
        this.tl = gsap.timeline({ paused: true });
        this._init();
    }

    _init() {
        this._anmationTimeline();
        this._eventDelegation();
    }

    _anmationTimeline() {
        this.tl.set('.announce2ndmodal__content', { display: 'none' });
        this.tl.set('.announce2ndmodal__intro__bg', { opacity: 0 });
        this.tl.set('.announce2ndmodal__intro__mv', { opacity: 0, xPercent: -50, yPercent: -50, rotation: 360 * 5, scale:1.5, filter: "grayscale(90%) brightness(0.5)" });

        // 暗い中回転して写真が入ってくる
        this.tl.to('.announce2ndmodal__content[data-page="1"]', { duration: 0.1, display: 'block' }, 0.1);
        this.tl.to('.announce2ndmodal__intro__mv', { duration: 1.5, opacity: 1, xPercent: -50, yPercent: -50, rotation: -10, scale: 1,ease: "power2.in" }, "<0.2");

        // 明るくなる
        this.tl.to('.announce2ndmodal__intro__bg', { duration: 0.8, opacity: 1 }, "+=0.3");
        this.tl.to('.announce2ndmodal__intro__mv', { duration: 0.3, filter: "grayscale(0%) brightness(4)" }, "<");
        this.tl.to('.announce2ndmodal__intro__mv', { duration: 1.0, filter: "grayscale(0%) brightness(1)" }, "<0.3");

        // 1ページ目が捌けて2ページ目が表示される
        this.tl.to('.announce2ndmodal__content[data-page="1"]', { duration: 0.5, opacity: 0, display: "none" }, "+=1.0");
        this.tl.to('.announce2ndmodal__content[data-page="2"]', { duration: 0.5, opacity: 1, display: "block" }, "<0");
    }

    startAnimation() {
        this.tl.restart();
    }

    _eventDelegation() {
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.js-announce2ndmodal_open');
            if (btn) {
                e.preventDefault();
                const announce = document.getElementById('announce2nd__modal');
                if (announce) {
                    announce.classList.add('-active');
                    document.body.classList.add('-lock');
                    this.startAnimation();
                }
            }
        });
    }
}
